<template>
    <div class="credit-tiles">
        <div class="credit-tiles__title">{{ title }}</div>
        <div class="credit-tiles__list">
            <div
                v-for="item in items"
                :key="item.key"
                :class="['credit-tiles__tile', { 'is-current': item.key === current }]"
            >
                <span class="credit-tiles__value">{{ leaves[item.key] != null ? leaves[item.key] : '—' }}</span>
                <span class="credit-tiles__label">{{ item.label }}</span>
            </div>
        </div>
    </div>
</template>

<script>
// Remaining leave credits (vl / sl / al) shown as three tiles, with the request's own type outlined
export default {
    props: {
        title: {
            type: String,
            default: 'Remaining leave credits',
        },
        leaves: {
            type: Object,
            default: () => ({}),
        },
        // 'vl' | 'sl' | 'al'
        current: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            items: [
                { key: 'vl', label: 'Vacation' },
                { key: 'sl', label: 'Emergency/Sick' },
                { key: 'al', label: 'Appreciation' },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.credit-tiles {
    padding: 14px 16px;
    border-radius: 8px;
    background: #f8f8f9;

    &__title {
        margin-bottom: 10px;
        color: #808695;
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.3px;
    }

    &__list {
        display: flex;
        gap: 10px;
    }

    &__tile {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10px 6px;
        border: 1px solid #e8eaec;
        border-radius: 6px;
        background: #fff;

        &.is-current {
            border-color: #211841;
            box-shadow: inset 0 0 0 1px #211841;
        }
    }

    &__value {
        font-size: 20px;
        font-weight: 700;
        color: #211841;
    }

    &__label {
        font-size: 12px;
        color: #808695;
        text-align: center;
    }
}
</style>
